import { render, staticRenderFns } from "./BadgeStatusStock.vue?vue&type=template&id=176f2898&scoped=true&"
import script from "./BadgeStatusStock.vue?vue&type=script&lang=js&"
export * from "./BadgeStatusStock.vue?vue&type=script&lang=js&"
import style0 from "./BadgeStatusStock.vue?vue&type=style&index=0&id=176f2898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176f2898",
  null
  
)

export default component.exports